export default {
    "人民卫生出版社": [
        { "name": "舌的形体结构", "ifShowSecond": true, "index": "1" },
        {
            "name": "舌诊原理",
            "index": "2",
            "ifShowSecond": true,
            "children": [
                { "name": "舌与脏腑经络的关系", "ifShowThird": true, "index": "2.1" },
                { "name": "舌与气血津液的关系", "ifShowThird": true, "index": "2.2" },
                { "name": "脏腑在舌面上的分部", "ifShowThird": true, "index": "2.3" }
            ]
        },
        {
            "name": "舌诊的方法和注意事项",
            "index": "3",
            "ifShowSecond": true,
            "children": [
                { "name": "望舌的体位和伸舌姿势", "ifShowThird": true, "index": "3.1" },
                {
                    "name": "望舌的方法",
                    "index": "3.2",
                    "ifShowThird": true,
                    "children": [
                        { "name": "望舌顺序", "index": "3.2.1" },
                        { "name": "刮舌法和揩舌法", "index": "3.2.2" },
                    ]
                },
                {
                    "name": "注意事项",
                    "index": "3.3",
                    "ifShowThird": true,
                    "children": [
                        { "name": "光线", "index": "3.3.1" },
                        { "name": "姿势", "index": "3.3.2" },
                        { "name": "顺序", "index": "3.3.3" },
                        { "name": "饮食", "index": "3.3.4" },
                        { "name": "年龄与体质", "index": "3.3.5" },
                        { "name": "季节与地域", "index": "3.3.6" },
                    ]
                }
            ]
        },
        {
            "name": "舌诊的内容",
            "index": "4",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "望舌质",
                    "index": "4.1",
                    "ifShowThird": true,
                    "children": [
                        { "name": "舌神", "index": "4.1.1" },
                        { "name": "舌色", "index": "4.1.2" },
                        { "name": "舌形", "index": "4.1.3" },
                        { "name": "舌态", "index": "4.1.4" },
                        { "name": "舌下络脉", "index": "4.1.5" },
                    ]
                },
                {
                    "name": "望舌苔",
                    "index": "4.2",
                    "ifShowThird": true,
                    "children": [
                        { "name": "苔质", "index": "4.2.1" },
                        { "name": "苔色", "index": "4.2.2" },
                    ]
                },
            ]
        },
        {
            "name": "舌象分析要点及舌诊的临床意义",
            "index": "5",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "舌象分析要点",
                    "index": "5.1",
                    "ifShowThird": true,
                    "children": [
                        { "name": "察舌的神气和胃气", "index": "5.1.1" },
                        { "name": "舌质和舌苔的综合判断", "index": "5.1.2" },
                        { "name": "舌象的动态分析", "index": "5.1.3" },
                    ]
                },
                {
                    "name": "舌诊的临床意义",
                    "index": "5.2",
                    "ifShowThird": true,
                    "children": [
                        { "name": "判断邪正盛衰", "index": "5.2.1" },
                        { "name": "分析病位浅深", "index": "5.2.2" },
                        { "name": "区别病邪性质", "index": "5.2.3" },
                        { "name": "分析病势进退", "index": "5.2.4" },
                        { "name": "估计病情预后", "index": "5.2.5" },
                    ]
                },
            ]
        },
    ],
    "中国中医药出版社舌诊部分": [
        { "name": "舌的形体结构", "ifShowSecond": true, "index": "1" },
        {
            "name": "舌诊原理",
            "index": "2",
            "ifShowSecond": true,
            "children": [
                { "name": "脏腑经络联系于舌", "ifShowThird": true, "index": "2.1" },
                { "name": "舌面的脏腑分候", "ifShowThird": true, "index": "2.2" },
                { "name": "气血津液充养于舌", "ifShowThird": true, "index": "2.3" }
            ]
        },
        {
            "name": "舌诊的方法和注意事项",
            "index": "3",
            "ifShowSecond": true,
            "children": [
                { "name": "舌诊的方法", "ifShowThird": false, "index": "3.1" },
                {
                    "name": "舌诊的注意事项",
                    "index": "3.2",
                    "ifShowThird": true,
                    "children": [
                        { "name": "光线的影响", "index": "3.2.1" },
                        { "name": "饮食或药品的影响", "index": "3.2.2" },
                        { "name": "口腔对舌象的影响", "index": "3.2.3" },
                        { "name": "伸舌姿势的影响", "index": "3.2.4" },
                    ]
                },
            ]
        },
        {
            "name": "舌诊的内容和正常舌象",
            "index": "4",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "舌诊的内容",
                    "index": "4.1",
                    "ifShowThird": false,
                },
                {
                    "name": "正常舌象",
                    "index": "4.2",
                    "ifShowThird": false,
                },
                {
                    "name": "舌象的生理性变异",
                    "index": "4.3",
                    "ifShowThird": true,
                    "children": [
                        { "name": "年龄、性别因素", "index": "4.3.1" },
                        { "name": "体质禀赋因素", "index": "4.3.2" },
                        { "name": "气候环境因素", "index": "4.3.3" },
                    ]
                },
            ]
        },
        {
            "name": "望舌质",
            "index": "5",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "望舌神",
                    "index": "5.1",
                    "ifShowThird": true,
                    "children": [
                        { "name": "荣舌", "index": "5.1.1" },
                        { "name": "枯舌", "index": "5.1.2" },
                    ]
                },
                {
                    "name": "望舌色",
                    "index": "5.2",
                    "ifShowThird": true,
                    "children": [
                        { "name": "淡红舌", "index": "5.2.1" },
                        { "name": "淡白舌", "index": "5.2.2" },
                        { "name": "红舌", "index": "5.2.3" },
                        { "name": "绛舌", "index": "5.2.4" },
                        { "name": "青紫舌", "index": "5.2.5" },
                    ]
                },
                {
                    "name": "望舌形",
                    "index": "5.3",
                    "ifShowThird": true,
                    "children": [
                        { "name": "老、嫩舌", "index": "5.3.1" },
                        { "name": "胖、瘦舌", "index": "5.3.2" },
                        { "name": "点、刺舌", "index": "5.3.3" },
                        { "name": "裂纹舌", "index": "5.3.4" },
                        { "name": "齿痕舌", "index": "5.3.5" },
                    ]
                },
                {
                    "name": "望舌态",
                    "index": "5.4",
                    "ifShowThird": true,
                    "children": [
                        { "name": "痿软舌", "index": "5.4.1" },
                        { "name": "强硬舌", "index": "5.4.2" },
                        { "name": "歪斜舌", "index": "5.4.3" },
                        { "name": "颤动舌", "index": "5.4.4" },
                        { "name": "吐弄舌", "index": "5.4.5" },
                        { "name": "短缩舌", "index": "5.4.6" },
                    ]
                },
            ]
        },
        {
            "name": "望舌苔",
            "index": "6",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "望苔质",
                    "index": "6.1",
                    "ifShowThird": true,
                    "children": [
                        { "name": "薄、厚苔", "index": "6.1.1" },
                        { "name": "润、燥苔", "index": "6.1.2" },
                        { "name": "腻、腐苔", "index": "6.1.3" },
                        { "name": "剥（落）苔", "index": "6.1.4" },
                        { "name": "偏、全苔", "index": "6.1.5" },
                        { "name": "真、假苔", "index": "6.1.6" },
                    ]
                },
                {
                    "name": "望苔色",
                    "index": "6.2",
                    "ifShowThird": true,
                    "children": [
                        { "name": "白苔", "index": "6.2.1" },
                        { "name": "黄苔", "index": "6.2.2" },
                        { "name": "灰黑苔", "index": "6.2.3" },
                    ]
                },
            ]
        },
        {
            "name": "望舌下络脉",
            "index": "7",
            "ifShowSecond": false,
        },
        {
            "name": "舌象分析要点及舌诊的临床意义",
            "index": "8",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "舌象分析要点",
                    "index": "8.1",
                    "ifShowThird": true,
                    "children": [
                        { "name": "察舌的神气和胃气", "index": "8.1.1" },
                        { "name": "舌质和舌苔的综合判断", "index": "8.1.2" },
                        { "name": "舌象的动态分析", "index": "8.1.3" },
                    ]
                },
                {
                    "name": "舌诊的临床意义",
                    "index": "8.2",
                    "ifShowThird": true,
                    "children": [
                        { "name": "分辨病位浅深", "index": "8.2.1" },
                        { "name": "区别病邪性质", "index": "8.2.2" },
                        { "name": "判断邪正盛衰", "index": "8.2.3" },
                        { "name": "分析病势进退", "index": "8.2.4" },
                        { "name": "推测病情预后", "index": "8.2.5" },
                    ]
                },
            ]
        }
    ],
    "中国中医药出版社面诊部分": [
        {
            "name": "望色", "ifShowSecond": true, "index": "1", "children": [
                { "name": "综述", "ifShowThird": false, "index": "1.1" },
            ]
        },
        {
            "name": "望色的原理及意义", "ifShowSecond": true, "index": "2", "children": [
                { "name": "望面色的原理", "ifShowThird": false, "index": "2.1" },
                {
                    "name": "望色、泽的意义", "ifShowThird": true, "index": "2.2", "children": [
                        { "name": "颜色", "index": "2.2.1" },
                        { "name": "光泽", "index": "2.2.2" },
                    ]
                },
                { "name": "面部脏腑分候", "ifShowThird": false, "index": "2.3" },
            ]
        },
        {
            "name": "常色", "ifShowSecond": true, "ifHasContent": true, "index": "3", "children": [
                { "name": "主色", "ifShowThird": false, "index": "3.1" },
                { "name": "客色", "ifShowThird": false, "index": "3.2" },
            ]
        },
        {
            "name": "病色", "ifShowSecond": true, "ifHasContent": true, "index": "4", "children": [
                {
                    "name": "病色善恶", "ifShowThird": true, "ifHasContent": true, "index": "4.1", "children": [
                        { "name": "善色", "index": "4.1.1" },
                        { "name": "恶色", "index": "4.1.2" },
                    ]
                },
                {
                    "name": "五色主病", "ifShowThird": true, "ifHasContent": true, "index": "4.2", "children": [
                        { "name": "青色", "index": "4.2.1" },
                        { "name": "赤色", "index": "4.2.2" },
                        { "name": "黄色", "index": "4.2.3" },
                        { "name": "白色", "index": "4.2.4" },
                        { "name": "黑色", "index": "4.2.5" },
                    ]
                },
            ]
        },
        {
            "name": "望色十法", "ifShowSecond": false, "index": "5"
        },
        {
            "name": "望色的注意事项", "ifShowSecond": true, "index": "6", "children": [
                { "name": "排除非病理因素的影响", "ifShowThird": false, "index": "6.1" },
                { "name": "注意色与脉症互参分析", "ifShowThird": false, "index": "6.2" },
                { "name": "综合判断病色生克顺逆", "ifShowThird": false, "index": "6.3" },
            ]
        },

    ],
    "上海科学技术出版社": [
        {
            "name": "舌诊概说",
            "index": "1",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "舌的形态、结构、功能",
                    "ifShowThird": true,
                    "index": "1.1",
                },
                {
                    "name": "舌诊原理",
                    "ifShowThird": true,
                    "index": "1.2",
                    "children": [
                        { "name": "舌与脏腑经络的关系", "index": "1.2.1" },
                        { "name": "舌与气血津液的关系", "index": "1.2.2" },
                    ]
                },
                {
                    "name": "诊舌的方法和注意事项",
                    "ifShowThird": true,
                    "index": "1.3",
                    "children": [
                        { "name": "体位和伸舌姿势", "index": "1.3.1" },
                        { "name": "方法", "index": "1.3.2" },
                        { "name": "注意事项", "index": "1.3.3" },
                    ]
                },
                {
                    "name": "舌诊的内容和正常舌象",
                    "ifShowThird": true,
                    "index": "1.4",
                    "children": [
                        { "name": "内容", "index": "1.4.1" },
                        { "name": "正常舌象", "index": "1.4.2" },
                        { "name": "生理变异", "index": "1.4.3" },
                    ]
                }
            ]
        },
        {
            "name": "望舌质",
            "index": "2",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "舌神",
                    "ifShowThird": true,
                    "index": "2.1",
                },
                {
                    "name": "舌色",
                    "ifShowThird": true,
                    "index": "2.2",
                    "children": [
                        { "name": "淡红舌", "index": "2.2.1" },
                        { "name": "淡白舌", "index": "2.2.2" },
                        { "name": "红绛舌", "index": "2.2.2" },
                        { "name": "青紫舌", "index": "2.2.2" },
                    ]
                },
                {
                    "name": "舌形",
                    "ifShowThird": true,
                    "index": "2.3",
                    "children": [
                        { "name": "老舌和嫩舌", "index": "2.3.1" },
                        { "name": "胖舌和瘦舌", "index": "2.3.2" },
                        { "name": "裂纹舌", "index": "2.3.3" },
                        { "name": "芒刺舌", "index": "2.3.4" },
                        { "name": "齿痕舌", "index": "2.3.5" },
                    ]
                },
                {
                    "name": "舌态",
                    "ifShowThird": true,
                    "index": "2.4",
                    "children": [
                        { "name": "痿软舌", "index": "2.4.1" },
                        { "name": "强硬舌", "index": "2.4.2" },
                        { "name": "震颤舌", "index": "2.4.3" },
                        { "name": "歪斜舌", "index": "2.4.4" },
                        { "name": "吐弄舌", "index": "2.4.5" },
                        { "name": "短缩舌", "index": "2.4.6" },
                    ]
                },
                {
                    "name": "舌下络脉",
                    "ifShowThird": false,
                    "index": "2.5",
                },
            ]
        },
        {
            "name": "望舌苔",
            "index": "3",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "苔质",
                    "ifShowThird": true,
                    "index": "3.1",
                    "children": [
                        { "name": "薄苔和厚苔", "index": "3.1.1" },
                        { "name": "润苔、滑苔、燥苔和糙苔", "index": "3.1.2" },
                        { "name": "腐苔和腻苔", "index": "3.1.3" },
                        { "name": "剥落苔", "index": "3.1.4" },
                        { "name": "有根苔和无根苔", "index": "3.1.5" },
                    ]
                },
                {
                    "name": "苔色",
                    "ifShowThird": true,
                    "index": "3.2",
                    "children": [
                        { "name": "白苔", "index": "3.2.1" },
                        { "name": "黄苔", "index": "3.2.2" },
                        { "name": "灰黑苔", "index": "3.2.3" },
                    ]
                },
            ]
        },
        {
            "name": "舌象综合分析与舌诊临床意义",
            "index": "4",
            "ifShowSecond": true,
            "children": [
                {
                    "name": "舌质与舌苔合参",
                    "ifShowThird": false,
                    "index": "4.1",
                },
                {
                    "name": "舌诊的临床意义",
                    "ifShowThird": true,
                    "index": "4.2",
                    "children": [
                        { "name": "判断正气盛衰", "index": "4.2.1" },
                        { "name": "分辨病位深浅", "index": "4.2.2" },
                        { "name": "区别病邪性质", "index": "4.2.3" },
                        { "name": "推断病势进退", "index": "4.2.4" },
                        { "name": "估计病情预后", "index": "4.2.5" },
                    ]
                },
            ]
        }
    ]
};
